export default __webpack_public_path__ + "static/media/insight_not_select.19da20f8.svg";